import React from "react";
import styles from "./MenuButton.scss";

import { Clickable } from "../Clickable";

export const MenuButton = (props) => {
    return (
        <Clickable {...props} className={styles.base}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115 144">
                <path
                    fillRule="nonzero"
                    d="M57.59.08c33.2 0 56.7 23.5 56.7 57.63v14.18H85.56V57.71c0-18.28-11.37-29.65-28-29.65-16.63 0-28 11.37-28 29.65H.89C.89 23.58 24.39.08 57.59.08zM.89 143.7h113.4v-27.61H36l40.29-44.2H41.17L.89 116.09v27.61z"
                />
            </svg>
        </Clickable>
    );
};
